__turbopack_context__.v({
  "accordion": "Accordion-module-scss-module__j1-l8W__accordion",
});
